import { FC, useEffect } from "react";
import { useLocation } from "react-router-dom";

interface IProps { };

const HOME_HOST = process.env.REACT_APP_HOME_HOST;

const Blog: FC<IProps> = () => {

  const location = useLocation();

  useEffect(() => {
    const { pathname } = location;
    const arrPath = pathname.split("/");
    if (typeof window !== 'undefined') {
      if (arrPath.length >= 3) {
        if (arrPath[1] === 'en' || arrPath[1] === 'id') {
          if (arrPath[2] === 'article' || arrPath[2] === 'artikel') {
            window.location.href = `${HOME_HOST}/${arrPath[1]}/blog/${arrPath[3]}`;
          } else {
            window.location.href = `${HOME_HOST}/${arrPath[1]}/blog/${arrPath[2]}`;
          }
        } else {
          if (arrPath[1] === 'article') {
            window.location.href = `${HOME_HOST}/en/blog/${arrPath[2]}`;
          } else if (arrPath[1] === 'artikel') {
            window.location.href = `${HOME_HOST}/id/blog/${arrPath[2]}`;
          } else {
            window.location.href = `${HOME_HOST}/id/blog/${arrPath[1]}`;
          }
        }
      } else {
        window.location.href = `${HOME_HOST}`;
      }
    }
  }, [location]);

  return (
    <>
    </>
  );
}

export default Blog;